import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'

const FUNCTIONALIZATION_INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.extra.space.Functionalization,
    graphql.schema.SpaceFunctionalizationInput
  >({
    functionId: transformers.PASS_THROUGH,
    percent: transformers.PASS_THROUGH,
  }),
)

const FUNCTIONALIZATIONS_LIST = graphql.transformers.IN.list(
  graphql.transformers.IN.if(
    (f: ents.extra.space.Functionalization) => f.percent !== 0,
    FUNCTIONALIZATION_INPUT,
    graphql.transformers.IN.always(undefined),
  ),
  { onNullish: 'remove' },
)

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.extra.space.ServiceCenter.Input,
    graphql.schema.ServiceCenterInput
  >({
    functionalizations: graphql.transformers.IN.nonNull(
      FUNCTIONALIZATIONS_LIST,
    ),
    name: transformers.PASS_THROUGH,
  }),
)

export const UPDATES = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    Partial<ents.extra.space.ServiceCenter.Update>,
    graphql.schema.ServiceCenterInput
  >({
    functionalizations: graphql.transformers.IN.validate(
      FUNCTIONALIZATIONS_LIST,
      TypeAsserter.assertIsNotNullish,
    ),
    name: graphql.transformers.IN.validate(
      transformers.PASS_THROUGH,
      TypeAsserter.assertIsNotNullish,
    ),
  }),
)
